import React from "react";
import Dashboard from "../views/pages/dashboard/dashboard";
import StoreManage from "../views/pages/store/StoreManage";
import StoreConfig from "../views/pages/store/StoreConfig";
import PosUser from "../views/pages/user/PosUser";
import BrandList from "../views/pages/brand/BrandList";
import StoreKioskConfig from "../views/pages/store/StoreKioskConfig";
import StoreList from "../views/pages/store/StoreList";
import ProductRegister from "../views/pages/product/ProductRegister";
import ProductHandlingManage from "../views/pages/product/handling/ProductHandlingManage";
import ProductSearch from "../views/pages/product/ProductSearch";
import ProductLanguage from "../views/pages/product/ProductLanguage";
import ProductBrandMappingManagement from "../views/pages/product/mapping/ProductBrandMappingManage";
import CurrentSale from "../views/pages/sale/status/currentSale";
import DevSales from "../views/pages/sale/status/devSale";
import DaySales from "../views/pages/sale/status/dailySales";
import MonthlySales from "../views/pages/sale/status/monthlySales";
import DailyHourlySales from "../views/pages/sale/status/dailyHourlySales";
import ProductSales from "../views/pages/sale/status/productSales";
import SimpleStockManage from "../views/pages/stock/manage/SimpleStockManage";
import SaleReport from "../views/pages/sale/report/SaleReport";
import ErpSaleReport from "../views/pages/sale/status/ErpSaleReport";
import TouchKeyManage from "../views/pages/touch/TouchKeyManage";
import BillSaleDetailReport from "../views/pages/sale/status/billSaleDetailReport";
import CornerSaleReport from "../views/pages/sale/status/corner/cornerSaleReport";
import SaleRejectReport from "../views/pages/sale/status/reject/SaleRejectReport";
import StoreKitchen from "../views/pages/store/kitchen/StoreKitchen";
import StoreDevice from "../views/pages/store/device/StoreDevice";
import HourlySaleReport from "../views/pages/sale/report/hourly/hourlySaleRepoty";
import CompareSaleTR from "../views/pages/sale/status/compareSaleTR";
import ManualSaleRegister from "../views/pages/sale/manual/ManualSaleRegister";
import DeleteSaleData from "../views/pages/sale/manual/DeleteSaleData";
import CardSaleReport from "../views/pages/sale/report/CardSaleReport";
import ProductChain from "../views/pages/product/ProductChain";
import StoreCopy from "../views/pages/store/StoreCopy";
import TableList from "../views/pages/table/table/TableList";
import RegisterSaleCl from "../views/pages/sale/manual/RegisterSaleCl";

const Components = {
	"/main": Dashboard,
	"/store/manage": StoreManage,
	"/store/store-list": StoreList,
	"/store/config": StoreConfig,
	"/store/pos-user": PosUser,
	"/brand/list": BrandList,
	"/product/register": ProductRegister,
	"/product/handling": ProductHandlingManage,
	"/product/search": ProductSearch,
	"/product/language": ProductLanguage,
	"/sale/currentSale": CurrentSale,
	"/sale/dailySales": DaySales,
	"/sale/monthlySales": MonthlySales,
	"/sale/dailyHourlySales": DailyHourlySales,
	"/sale/productSales": ProductSales,
	"/stock/simple-stock-manage": SimpleStockManage,
	"/report/SaleReport": SaleReport,
	"/sale/erp-data": ErpSaleReport,
	"/sale/billSaleDetailReport": BillSaleDetailReport,
	"/sale/cornerSaleReport": CornerSaleReport,
	"/sale/saleRejectReport": SaleRejectReport,
	"/store/kitchen": StoreKitchen,
	"/store/device": StoreDevice,
	"/sale/hourlySaleReport": HourlySaleReport,
	"/sale/compareSaleTR": CompareSaleTR,
	"/sale/manual/ManualSaleRegister": ManualSaleRegister,
	"/sale/manual/deleteSaleData": DeleteSaleData,
	"/sale/cardSaleReport": CardSaleReport,
	"/product/chain": ProductChain,
	"/store/copy": StoreCopy,
	"/product/mapping": ProductBrandMappingManagement,
	"/store/kiosk/config": StoreKioskConfig,
    "/sale/manual/RegisterSaleCl": RegisterSaleCl,
	"/table/manage": TableList
}

export default (block, props) => {
	if (typeof Components[block.to] !== undefined) {
		return React.createElement(Components[block.to], props)
	}
}
